import {
  goalConverter as _goalConverter,
  newGoalConverter as _newGoalConverter,
} from '@griply/services';
import { Goal } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const goalConverter =
  _goalConverter as unknown as FirestoreDataConverter<Goal>;

export const newGoalConverter = _newGoalConverter;
